export const apiEndPoints = {
    WALLET:'/wallet'
}

export const baseUrl = {
    devUrl:'https://cortiqahealth-api-gateway-810bfj45.ue.gateway.dev',
    qaUrl:'https://cortiqahealth-api-gateway-aw3gb1hs.an.gateway.dev',
    prodUrl:'https://cortiqahealth-api-gateway-5euv44wa.uc.gateway.dev',
    uat:'https://cortiqahealth-api-gateway-axri8g6l.uc.gateway.dev/'
}